import { global } from ":global";
import type { ApiResponse } from "./_model";

export async function cancelSentRequest(props: { id: number }) {
  return global.api.getAuth(`/teaming/cancel-request/${props.id}/`).then((res) => {
    return res.data;
  });
}
